var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomizeChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27676_276500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 14.6673C6.23254 14.6673 4.53685 13.9649 3.28661 12.7147C2.03636 11.4645 1.33398 9.76876 1.33398 8.00065C1.33398 6.23254 2.03636 4.53685 3.28661 3.28661C4.53685 2.03636 6.23254 1.33398 8.00065 1.33398C9.76876 1.33398 11.4645 1.96613 12.7147 3.09134C13.9649 4.21656 14.6673 5.74269 14.6673 7.33398C14.6673 8.21804 14.3161 9.06589 13.691 9.69101C13.0659 10.3161 12.218 10.6673 11.334 10.6673H9.83398C9.61732 10.6673 9.40494 10.7277 9.22063 10.8416C9.03633 10.9555 8.88738 11.1184 8.79049 11.3122C8.69359 11.506 8.65257 11.723 8.67203 11.9388C8.69149 12.1545 8.77065 12.3607 8.90065 12.534L9.10065 12.8007C9.23065 12.974 9.30981 13.1801 9.32927 13.3959C9.34873 13.6117 9.30771 13.8286 9.21082 14.0224C9.11392 14.2162 8.96498 14.3792 8.78067 14.4931C8.59637 14.607 8.38398 14.6673 8.16732 14.6673H8.00065Z",
    stroke: "#6B7280",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99935 4.66667C9.18344 4.66667 9.33268 4.51743 9.33268 4.33333C9.33268 4.14924 9.18344 4 8.99935 4C8.81525 4 8.66602 4.14924 8.66602 4.33333C8.66602 4.51743 8.81525 4.66667 8.99935 4.66667Z",
    fill: "#6B7280",
    stroke: "#6B7280",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6673 7.33268C11.8514 7.33268 12.0007 7.18344 12.0007 6.99935C12.0007 6.81525 11.8514 6.66602 11.6673 6.66602C11.4832 6.66602 11.334 6.81525 11.334 6.99935C11.334 7.18344 11.4832 7.33268 11.6673 7.33268Z",
    fill: "#6B7280",
    stroke: "#6B7280",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.33333 8.66667C4.51743 8.66667 4.66667 8.51743 4.66667 8.33333C4.66667 8.14924 4.51743 8 4.33333 8C4.14924 8 4 8.14924 4 8.33333C4 8.51743 4.14924 8.66667 4.33333 8.66667Z",
    fill: "#6B7280",
    stroke: "#6B7280",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.66732 5.33268C5.85141 5.33268 6.00065 5.18344 6.00065 4.99935C6.00065 4.81525 5.85141 4.66602 5.66732 4.66602C5.48322 4.66602 5.33398 4.81525 5.33398 4.99935C5.33398 5.18344 5.48322 5.33268 5.66732 5.33268Z",
    fill: "#6B7280",
    stroke: "#6B7280",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27676_276500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizeChart);
export default __webpack_public_path__ + "static/media/customizeChart.384c25c5fd058eee9b26f08a7ae1978d.svg";
export { ForwardRef as ReactComponent };